var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBold = function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "bold_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H6v8h8a4 4 0 1 0 0-8ZM15 12H6v8h9a4 4 0 1 0 0-8Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgBold as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTQgNEg2VjEySDE0QzE1LjA2MDkgMTIgMTYuMDc4MyAxMS41Nzg2IDE2LjgyODQgMTAuODI4NEMxNy41Nzg2IDEwLjA3ODMgMTggOS4wNjA4NyAxOCA4QzE4IDYuOTM5MTMgMTcuNTc4NiA1LjkyMTcyIDE2LjgyODQgNS4xNzE1N0MxNi4wNzgzIDQuNDIxNDMgMTUuMDYwOSA0IDE0IDRaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNMTUgMTJINlYyMEgxNUMxNi4wNjA5IDIwIDE3LjA3ODMgMTkuNTc4NiAxNy44Mjg0IDE4LjgyODRDMTguNTc4NiAxOC4wNzgzIDE5IDE3LjA2MDkgMTkgMTZDMTkgMTQuOTM5MSAxOC41Nzg2IDEzLjkyMTcgMTcuODI4NCAxMy4xNzE2QzE3LjA3ODMgMTIuNDIxNCAxNi4wNjA5IDEyIDE1IDEyWiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";